import React, { useEffect, useRef, useState } from "react";
import UncontrolledExample from "./carousel";
import { backend, categoryurl, mediaurl, producturl } from "../../../../path";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../../../components/whatsapp connect";
import { Rating } from "@mui/material";
import { Helmet } from "react-helmet";
import LoaderMain from "../../../layout/header/loader_sub";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi2";
import { PiShoppingCartThin } from "react-icons/pi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import { CiHeart } from "react-icons/ci";
import { VscHeartFilled } from "react-icons/vsc";
import { RxPadding } from "react-icons/rx";
import StarIcon from "@mui/icons-material/Star";
import { trimDescriptionToTen } from "../../../../utils/trimDescription";
import TopSellingComponent from "../../topselling/Index";
import HeroSlider from "./HeroSlider";
import ProductSlider from "../../../components/slider/PopularSlider";
import PopularSliderMobile from "../../../components/slider/PopularSliderMobile";

function HomepageNew(props) {
  const [value, setValue] = React.useState(2);
  const [hover, setHover] = React.useState(-1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesToShow = 4; // Adjust based on your responsive needs

  const handleNextPop = () => {
    setCurrentSlide((prev) =>
      Math.min(prev + 1, data.getPopularProduct.length - slidesToShow)
    );
  };

  const handlePrevPop = () => {
    setCurrentSlide((prev) => Math.max(prev - 1, 0));
  };
  const desktopSliderRef = useRef(null);
  const mobileSliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    fade: true,
    waitForAnimate: false,
  };
  const Topsellingsettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const Topsettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    className: "slider variable-width",
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handlePrev = () => {
    const ref = isMobile ? mobileSliderRef : desktopSliderRef;
    if (ref.current) ref.current.slickPrev();
  };

  const handleNext = () => {
    const ref = isMobile ? mobileSliderRef : desktopSliderRef;
    if (ref.current) ref.current.slickNext();
  };
  // useEffect(()=>{
  //   let userdata = JSON.parse(localStorage.getItem('userdata'));
  //   fetch(backend + "tokentest", {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization:`Bearer ${userdata.access_token}`,
  //       "Content-Type": "application/json",
  //     }
  //   })
  //     .then((response) => {
  //       response.json().then((data) => {
  //       console.log(data)

  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error during login:", error);
  //     });
  // },[])
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [catData, setCatData] = useState([]);

  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [subEmail, setSubEmail] = useState("");

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const fetchData = () => {
    setLoading(true);

    fetch(backend + "getallspecialproduts", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchDataCat = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCatData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchData();
    fetchDataCat();
  }, []);

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };
  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    fetch(backend + "addsubscription", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: subEmail }),
    })
      .then((response) => {
        setSubEmail("");
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            console.error("Email Already Exists");
            toast.error("Email Already Exists", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            console.error("Registration failed");
            toast.error("Registration failed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          toast.success("Subscribed Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        console.error("Error during registration:", error);
        toast.error("Registration failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  const heroImages = [
    {
      id: 1,
      src: "/storage/general/Frame 1618873226 (1).png",
      mob_src: "/storage/general/Rectangle 2.png",
      route: "/category/art-crafts",
      bgColor: "#682c18ff",
    },
    {
      id: 2,
      src: "/storage/general/Frame 1618873225.svg",
      mob_src: "/storage/general/Rectangle 1.svg",
      route: "/subcategory/kerala-special-spices",
      bgColor: "#224F01",
    },

    {
      id: 3,
      src: "/storage/general/Frame 1618873227.svg",
      mob_src: "/storage/general/Rectangle 3.png",
      route: "/subcategory/kerala-special-snacks",
      bgColor: "#a89206ff",
    },
  ];
  function getFirstImageUrl(data) {
    const producturl = "https://keralaspecial.in/server/public/upload/products";

    // Check if data is a valid string
    if (typeof data !== "string" || !data.trim()) {
      console.error("Invalid data provided:", data);
      return null; // Return null or an appropriate default value
    }

    try {
      // Use a regular expression to extract all strings inside double quotes
      let matches = data
        .match(/"([^"]*)"/g)
        ?.map((item) => item.replace(/"/g, ""));

      // Check if matches exist and get the first value
      if (matches && matches.length > 0) {
        let firstImage = matches[0];
        // Join the base URL with the first image filename
        return `${producturl}/${firstImage}`;
      } else {
        console.error("No matches found in data:", data);
        return null;
      }
    } catch (error) {
      console.error("Error processing data:", error);
      return null;
    }
  }
  const scrollDown = () => {
    //function to scroll down 100px
    window.scrollBy(0, 1000);
  };
  function trimText(text, maxLength = 35) {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  }
  const handleAyurvedha = () => {
    navigate("/category/ayurveda");
  };
  const handleProduct = () => {
    navigate("/category/handlooms");
  };
  const handleCategoryMain = (cat) => {
    // sessionStorage.setItem("categoryId", cat);
    // setSubcategory(false)
    // props?.SearchFetch();
    navigate(`/category/${cat}`);
    // window.location.reload();
  };
  const [isWideScreen, setIsWideScreen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1400);
      setIsSmallScreen(window.innerWidth < 1025);
    };

    // Initial check
    handleResize();

    // Listen for screen resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  const filteredDeals = data?.getDealOfTheDay?.filter(
    (item) => item?.sale_price > 3000
  );

  const dealsToRender = isWideScreen
    ? filteredDeals
    : isSmallScreen
      ? filteredDeals?.slice(0, 3)
      : filteredDeals?.slice(0, 2);

  const filteredDealsLeft = data.getDealOfTheDay
    ?.slice(2, 10)
    .filter((item) => item.sale_price < 3000);

  const dealsToRenderLeft = isWideScreen
    ? filteredDealsLeft?.slice(0, 7)
    : filteredDealsLeft?.slice(0, 5);


  const catDataLocal = [
    {
      category_id: 1,
      category_name: "Handlooms",
      category_slug: "/category/handlooms",
      logo: "/storage/category/Frame 158.png",
    },
    {
      category_id: 2,
      category_name: "Herbals",
      category_slug: "/subcategory/diabetes-care",
      logo: "/storage/category/Frame 159.png",
    },
    {
      category_id: 3,
      category_name: "Savory & Crispy",
      category_slug: "/subcategory/kerala-special-snacks",
      logo: "/storage/category/Frame 160.png",
    },
    {
      category_id: 4,
      category_name: "Spices & Aromatics",
      category_slug: "/subcategory/kerala-special-spices",
      logo: "/storage/category/Frame 161.png",
    },
    {
      category_id: 5,
      category_name: "Kerala Heritage Decor",
      category_slug: "",
      logo: "/storage/category/Frame 162.png",
    }
  ]
  return (
    <>
      {loading && <LoaderMain />}

      <Helmet>
        <title>Best online products in kerala</title>
        <meta
          name="description"
          content="Discover Kerala's finest products online! Handicrafts, spices, Ayurveda, handlooms & more. Fast & reliable shipping."
        />
        <meta
          name="keywords"
          content="online shopping,online shopping sites,online store"
        />
      </Helmet>
      <main>
        {/* ----------------------------------------------------- */}
        {/* Hero section start */}
        <Hero>
          <div className="slider-container">
            {/* <Slider {...settings}>
              {heroImages.map((data, index) => {
                return (
                  <Slide key={data.id} className="hero">
                    <ImageContainer className="hero">
                      <img src={data.src} alt="Image not found" />
                    </ImageContainer>
                    <button style={{ background: data.bgColor }}>
                      <a href={data.route}>Shop Now</a>
                      <span>
                        <HiOutlineArrowRight />
                      </span>
                    </button>
                  </Slide>
                );
              })}
            </Slider> */}
            <HeroSlider heroImages={heroImages} />
          </div>
        </Hero>
        <MobileHero>
          <div className="slider-container x">
            <Slider {...settings}>
              {heroImages.map((data, index) => {
                return (
                  <MobileSlide key={data.id} className="hero x">
                    <ImageContainer className="hero">
                      <img src={data.mob_src} alt="Image not found" />
                    </ImageContainer>
                    <button style={{ background: data.bgColor }}>
                      <a href={data.route}>Shop Now</a>
                      <span>
                        <HiOutlineArrowRight />
                      </span>
                    </button>
                  </MobileSlide>
                );
              })}
            </Slider>
          </div>
        </MobileHero>
        {/* Hero section end */}
        {/* ----------------------------------------------------- */}
        {/* Experience section start */}
        <Experience className="top">
          <div className="wrapper">
            <Container className="experience">
              <Section className="experience">
                {/* <ImageContainer className="experience"> */}
                <img
                  src="/storage/general/hugeicons_truck-delivery.svg"
                  alt="delivery"
                />
                {/* </ImageContainer> */}
                <h5>Home Delivery</h5>
                <ItalicText>
                  "Fast and safe delivery right to your doorstep."
                </ItalicText>
              </Section>
              <Section className="experience">
                {/* <ImageContainer className="experience"> */}
                <img src="/storage/general/7+.svg" alt="experience" />
                {/* </ImageContainer> */}
                <h5>Years Experience</h5>
                <ItalicText>"Trusted by customers since day one."</ItalicText>
              </Section>
              <Section className="experience">
                {/* <ImageContainer className="experience"> */}
                <img src="/storage/general/Group.svg" alt="experience" />
                {/* </ImageContainer> */}
                <h5> Best Value</h5>
                <ItalicText>
                  "Quality products at prices you’ll love."
                </ItalicText>
              </Section>
              <Section className="experience">
                {/* <ImageContainer className="experience"> */}
                <img src="/storage/general/cil_happy.svg" alt="people" />
                {/* </ImageContainer> */}
                <h5>Customer Satisfaction</h5>
                <ItalicText>
                  "Thousands of happy customers and growing."
                </ItalicText>
              </Section>
            </Container>
          </div>
        </Experience>
        {/* Experience section end */}
        {/* ----------------------------------------------------- */}

        {/* Categories List Sectio */}
        <section className="wrapper">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div
              className="
        grid grid-cols-5 gap-2 mt-10
        sm:grid-cols-5 sm:gap-3
        lg:mt-16 lg:gap-4 lg:grid-cols-5
      "
            >
              {catDataLocal &&
                catDataLocal.slice(0, 5).map((item) => (
                  <div
                    key={item.category_id}
                    className="relative group flex flex-col items-center"
                    onClick={() => {
                      navigate(item.category_slug);
                    }}
                  >
                    <div
                      className="
                w-[60px] h-[60px] 
                sm:w-[120px] sm:h-[120px] 
                lg:w-[160px] lg:h-[160px]
                overflow-hidden rounded-[12px] border
              "
                      style={{
                        borderColor: "#EDEDED",
                        background: "#EDEDED",
                      }}
                    >
                      <img
                        className="w-full h-full object-cover transition-all duration-300"
                        src={item.logo}
                        alt={item.logo}
                      />
                    </div>
                    <div className="mt-2 lg:mt-4">
                      <div className="flex justify-center">
                        <h3
                          className="text-[12px] sm:text-[14px] lg:text-[15px] font-semibold text-gray-900 leading-[100%] font-[Poppins] max-w-[240px] truncate text-center"
                          title={item?.category_name}
                        >
                          <Link to="#">{item?.category_name}</Link>
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>

        {/* Deals section start */}
        <section>
          <div className="container-fluid p-20 ">
            {/* For medium screens and up (centered) */}
            {/* <div className="hidden md:flex justify-center">
              <img
                src="/storage/general/Today’s Deals.svg"
                alt="Today's Deals"
                // className="w-auto h-[26px]"
              />
            </div> */}

            {/* For small screens (left-aligned with custom size) */}
            <div className="flex md:hidden justify-start">
              <img
                src="/storage/general/Today’s Deals.svg"
                alt="Today's Deals"
                className="w-[150px] h-[26px] opacity-100"
                style={{ transform: "rotate(0deg)" }}
              />
            </div>
            <Deals>
              <Left className="deals-left">
                {/* Static full-cover image card */}
                <Card key="static-image-card" style={{ overflow: "hidden" }}>
                  {/* <CardImageContainerS style={{ cursor: "pointer" }}> */}
                  <img
                    src="storage/general/Frame 147 (1).svg"
                    alt="Special Offer"
                    onClick={() => navigate("/deals")}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      cursor: "pointer",
                    }}
                  />
                  {/* </CardImageContainerS> */}
                </Card>

                {/* Then render the API deals */}
                {data &&
                  data.getDealOfTheDay &&
                  dealsToRenderLeft.map((item, index) => {
                    return (
                      <Card key={item.product_id}>
                        <Top>
                          <RatingBox>
                            <span style={{ fontSize: "14px", color: "#fff" }}>
                              {Number(item.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "14px", color: "#fff" }}
                            />
                          </RatingBox>
                          <LikeBox
                            onClick={() => handleAddToWishList(item.product_id)}
                          >
                            <img src="/storage/general/Icon.svg" alt="wish" />
                          </LikeBox>
                          <CardImageContainer
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <img
                              src={producturl + item.thumbnail}
                              alt="Image not found"
                            />
                          </CardImageContainer>
                        </Top>
                        <Bottom className="withWhite">
                          <p
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {item.product_name}
                          </p>
                          <div className="flex items-baseline py-3">
                            <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins]">
                              ₹{item.sale_price}/-
                            </span>
                            {item.mrp && (
                              <span className="font-poppins font-light italic text-sm leading-none line-through text-[#db0f0f] ps-4">
                                {item.mrp}
                              </span>
                            )}
                          </div>
                          <OutlinedGreenButton
                            onClick={() => handleAddCart(item.product_id)}
                          >
                            Add to Cart
                          </OutlinedGreenButton>
                        </Bottom>
                      </Card>
                    );
                  })}
              </Left>

              <Right>
                {data &&
                  data.getDealOfTheDay &&
                  dealsToRender.map((item, index) => {
                    return (
                      <CardRight key={item.product_id}>
                        <Top>
                          <RatingBox>
                            <span style={{ fontSize: "14px", color: "#fff" }}>
                              {Number(item.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "14px", color: "#fff" }}
                            />
                          </RatingBox>
                          <LikeBox
                            onClick={() => handleAddToWishList(item.product_id)}
                          >
                            <img src="/storage/general/Icon.svg" alt="wish" />
                          </LikeBox>
                          <CardImageContainer
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <img
                              src={producturl + item.thumbnail}
                              alt="Image not found"
                            />
                          </CardImageContainer>
                        </Top>
                        <Bottom className="withWhite">
                          <p
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {item.product_name}
                          </p>
                          <div className="flex items-baseline py-3">
                            <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                              ₹{item.sale_price}/-
                            </span>
                            {item.mrp && (
                              <span className="font-poppins font-light italic text-sm leading-none line-through text-[#db0f0f] ps-4">
                                {item.mrp}
                              </span>
                            )}
                          </div>
                          <OutlinedOrangeButton
                            onClick={() => handleAddCart(item.product_id)}
                          >
                            Add to Cart
                          </OutlinedOrangeButton>
                        </Bottom>
                      </CardRight>
                    );
                    //   return (
                    //     <Card>
                    //       <Top>
                    //         <Like
                    //           onClick={() => handleAddToWishList(item.product_id)}
                    //         >
                    //           <CiHeart />
                    //         </Like>
                    //         <CardImageContainer
                    //           onClick={() =>
                    //             handleProductRoute(item.product_slug)
                    //           }
                    //         >
                    //           <img
                    //             src={getFirstImageUrl(item.images)}
                    //             alt="Image not found"
                    //           />
                    //         </CardImageContainer>
                    //       </Top>
                    //       <Bottom className="withbg">
                    //         <p
                    //           onClick={() =>
                    //             handleProductRoute(item.product_slug)
                    //           }
                    //         >
                    //           {item.product_name}
                    //         </p>
                    //         <Rating
                    //           name="hover-feedback"
                    //           value={item.average_stars}
                    //           precision={0.5}
                    //           readOnly
                    //           // getLabelText={getLabelText}
                    //           onChange={(event, newValue) => {
                    //             setValue(newValue);
                    //           }}
                    //           onChangeActive={(event, newHover) => {
                    //             setHover(newHover);
                    //           }}
                    //           emptyIcon={
                    //             <StarIcon
                    //               style={{ opacity: 0.55 }}
                    //               fontSize="inherit"
                    //             />
                    //           }
                    //         />
                    //         <DescriptionButton>
                    //           <h3>₹ {item.sale_price}</h3>
                    //           <CartBtn>
                    //             <button
                    //               onClick={() => handleAddCart(item.product_id)}
                    //             >
                    //               <PiShoppingCartThin />
                    //             </button>
                    //           </CartBtn>
                    //         </DescriptionButton>
                    //       </Bottom>
                    //     </Card>
                    //   );
                  })}{" "}
              </Right>
            </Deals>
          </div>
          <MobileDeals>
            <div className="slider-container">
              <Slider {...Topsettings}>
                {data &&
                  data.getDealOfTheDay &&
                  data.getDealOfTheDay.map((item, index) => {
                    return (
                      <CardMobile key={item.product_id}>
                        <Top>
                          <RatingBox>
                            <span style={{ fontSize: "12px", color: "#fff" }}>
                              {Number(item.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "12px", color: "#fff" }}
                            />
                          </RatingBox>
                          <LikeBox
                            onClick={() => handleAddToWishList(item.product_id)}
                          >
                            <img src="/storage/general/Icon.svg" alt="wish" />
                          </LikeBox>
                          <CardImageContainerMobile
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <img
                              src={producturl + item.thumbnail}
                              alt="Image not found"
                            />
                          </CardImageContainerMobile>
                        </Top>
                        <BottomMobile className="withWhite">
                          <p
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {trimText(item.product_name)}
                          </p>
                          <div className="flex items-baseline py-3">
                            <span className="text-[14px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                              ₹{item.sale_price}/-
                            </span>
                            {item.mrp && (
                              <span className="font-poppins font-light italic text-[9px] leading-none line-through text-[#db0f0f] ps-4">
                                {item.mrp}
                              </span>
                            )}
                          </div>
                          <button
                            onClick={() => handleAddCart(item.product_id)}
                            className={`
                          w-[74px] h-[24px] flex items-center justify-center gap-[11px] rounded-[10px] 
                          font-poppins font-medium text-[8px] leading-none tracking-normal cursor-pointer 
                          opacity-100 transition-all duration-300
                          ${item.sale_price > 3000
                                ? "bg-[#fa9801] hover:bg-white hover:text-[#fa9801] hover:border hover:border-[#fa9801]"
                                : "border border-[#187837] text-[#187837] hover:bg-[#187837] hover:text-white"
                              }
                        `}
                          >
                            Add to Cart
                          </button>
                        </BottomMobile>
                      </CardMobile>
                    );
                  })}
              </Slider>
            </div>
          </MobileDeals>
        </section>
        {/* Deals section end */}
        {/* ----------------------------------------------------- */}
        {/* Popular section start */}

        {/* <section class="py-12 bg-white sm:py-16 lg:py-20 wrapper">
          <div className="grid grid-cols-2">
            <div className="mx-auto">
              <img src="/storage/general/Frame 147.svg" alt="popular" />
            </div>
            <div class="mx-auto sm:px-6 max-w-7xl">
              <div class="grid grid-cols-2 gap-3 mt-10 lg:mt-16 lg:gap-4 lg:grid-cols-4 xl:grid-cols-5 xl:gap-5">
                {data.getPopularProduct &&
                  data.getPopularProduct.slice(0, 5).map((item) => (
                    <div
                      key={item.product_id}
                      class="relative group  justify-items-center"
                    >
                      <div
                        className="w-[255px] h-[255px] overflow-hidden rounded-[23px] border"
                        style={{ borderColor: "rgba(237, 237, 237, 1)" }}
                      >
                        <img
                          className="w-full h-full object-cover transition-all duration-300 group-hover:scale-125"
                          src={producturl + item.thumbnail}
                          alt={item.product_name}
                        />
                      </div>

                      <div class="absolute left-3 top-3">
                        <p class="sm:px-3 sm:py-1.5 px-1.5 py-1 text-[8px] sm:text-xs font-bold tracking-wide text-gray-900 uppercase bg-white rounded-full">
                          <RatingBox>
                            <span style={{ fontSize: "14px", color: "#fff" }}>
                              {Number(item?.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "14px", color: "#fff" }}
                            />
                          </RatingBox>
                        </p>
                      </div>
                      <div className="mt-4 mx-3">
                        <div>
                          <h3
                            className="text-[15px] font-medium text-gray-900 leading-[100%] font-[Poppins] max-w-[240px] truncate"
                            title={item?.product_name}
                          >
                            <a href="#">
                              {item?.product_name}
                              <span
                                className="absolute inset-0"
                                aria-hidden="true"
                              ></span>
                            </a>
                          </h3>
                        </div>
                      </div>

                      <div className=" mt-4 space-x-4">
                        <div></div>

                        <div className="text-left">
                          <p className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                            ₹{item?.sale_price}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </section> */}
        <section className="hidden lg:block pt-12 bg-white sm:pt-16 lg:pt-10 wrapper max-h-[440px] ">
          <div className="grid grid-cols-[255px_1fr] gap-6">
            {/* Left Column – Smaller */}
            <div className="flex items-start justify-center">
              <img src="/storage/general/Frame 147.svg" alt="popular" onClick={() => navigate("/popular")} className="cursor-pointer" />
            </div>
            {/* Right Column – Wider */}
            <div className="max-w-100 w-full relative">
              <ProductSlider
                data={data}
                producturl={producturl}
                handleProductRoute={handleProductRoute}
                handleAddToWishList={handleAddToWishList}
                handleAddCart={handleAddCart}
              />
            </div>{" "}
          </div>
        </section>
        <section className="block lg:hidden p-4 bg-[#187837] wrapper rounded-[27px]">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-bold">
                <img src="/storage/general/popular.svg" alt="popular" onClick={() => navigate("/popular")} className="cursor-pointer" />
              </h2>
            </div>
            <button className="text-[#187837] bg-white text-xs font-medium w-[113px] h-[35px] rounded-[10px] border border-[#187837]">
              View all
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {data?.getPopularProduct?.slice(0, 6).map((item) => (
              <div key={item.product_id} className="w-[146px]">
                <div className="relative">
                  <RatingBox>
                    <span style={{ fontSize: "12px", color: "#fff" }}>
                      {Number(item.average_stars) || 4}
                    </span>
                    <StarIcon style={{ fontSize: "12px", color: "#fff" }} />
                  </RatingBox>
                  <LikeBox onClick={() => handleAddToWishList(item.product_id)}>
                    <img src="/storage/general/Icon.svg" alt="wish" />
                  </LikeBox>

                  <div className="w-[146px] h-[146px] rounded-[23px] overflow-hidden">
                    <img
                      src={producturl + item.thumbnail}
                      alt={item.product_name}
                      className="w-full h-full object-cover"
                      onClick={() => handleProductRoute(item.product_slug)}
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <p
                    className="text-xs font-medium text-gray-900 line-clamp-2 text-white cursor-pointer"
                    onClick={() => handleProductRoute(item.product_slug)}
                  >
                    {item.product_name}
                  </p>
                  <div className="flex items-center justify-between mt-1">
                    <span className="font-poppins font-medium text-[24px] leading-[100%] text-white cursor-pointer">
                      ₹{item.sale_price}
                    </span>
                    {item.mrp && (
                      <span className="font-poppins font-bold text-[14px] leading-[100%] line-through text-[#F45656] px-1 rounded">
                        ₹{item.mrp}
                      </span>
                    )}
                  </div>
                  <button
                    onClick={() => handleAddCart(item.product_id)}
                    className={`
                          w-[74px] h-[24px] flex items-center justify-center gap-[11px] rounded-[10px] 
                          font-poppins font-medium text-[8px] leading-none tracking-normal cursor-pointer 
                          opacity-100 transition-all duration-300
                          ${item.sale_price > 3000
                        ? "bg-[#fa9801] hover:bg-c hover:text-[#fa9801] hover:border hover:border-[#fa9801]"
                        : "border border-[#187837] text-[#fff] hover:bg-[#187837] hover:text-white"
                      }
                        `}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Experience section end */}
        {/* ----------------------------------------------------- */}
        {/* ----------------------------------------------------- */}
        {/* Unveiling section start */}
        <section className="wrapper hidden md:block">
          <Unveiling>
            <ImageContainer className="unveiling-banner ">
              <img src="/storage/general/banner1-2.png" alt="Image not found" />
            </ImageContainer>
            <div className="wrapper">
              <ContainerFull className="unveiling">
                <Left className="unveiling">
                  <span className="badge">Daily Ayurveda Spotlight</span>
                  <h3>Unveiling Ayurvedic Delights for the Day </h3>
                  <p className="subcopy">
                    Discover the essence of holistic wellness with our curated
                    selection of Ayurvedic treasures. From rejuvenating skin
                    care to nourishing herbal supplements, embark on a journey
                    of self-care and vitality.
                  </p>
                  <ul className="benefits">
                    <li>Curated rituals for balanced living</li>
                    <li>Authentic craftsmanship from Kerala</li>
                    <li>Freshly packed and delivered nationwide</li>
                  </ul>
                  <div className="cta-group">
                    <button onClick={handleAyurvedha}>
                      <span>Shop Now</span>
                      <span>
                        <HiOutlineArrowRight />
                      </span>
                    </button>
                    <button type="button" className="secondary" onClick={handleAyurvedha}>
                      Explore Ayurvedic Range
                    </button>
                  </div>
                </Left>
                <RightUnviel className="unveiling">
                  <div className="visual-card">
                    <div className="visual-glow" />
                    <ImageContainer className="unveiling">
                      <img
                        src="/storage/general/banner1-3.png"
                        alt="Image not found"
                      />
                    </ImageContainer>
                    <div className="visual-card__badge">Pure &amp; Potent</div>
                    <div className="visual-card__note">
                      <span>Hand-picked herbs, freshly crafted</span>
                      <span>Elevate your daily wellness ritual</span>
                    </div>
                  </div>
                </RightUnviel>
              </ContainerFull>
            </div>
          </Unveiling>
        </section>

        {/* Unveiling section end */}
        {/* ----------------------------------------------------- */}
        {/* ----------------------------------------------------- */}
        {/* Top Selling section start */}
        <TopSelling>
          <div className="wrapper hidden md:block">
            <h2>
              <ButtonContainer>
                <img src="/storage/general/Top Selling.svg" alt="top selling" onClick={() => navigate("/top-selling")} className="cursor-pointer" />
                <div className="flex items-center gap-2">
                  <TopSellingButton onClick={handlePrev}>
                    <HiOutlineArrowLeft />
                  </TopSellingButton>
                  <TopSellingButton onClick={handleNext}>
                    <HiOutlineArrowRight />
                  </TopSellingButton>
                </div>
              </ButtonContainer>
            </h2>
            <div className="slider-container">
              <Slider ref={desktopSliderRef} {...Topsellingsettings}>
                {data &&
                  data.getTopSelling &&
                  data.getTopSelling.map((item, index) => {
                    return (
                      <CardTopSelling key={item.product_id}>
                        <Top>
                          <RatingBox>
                            <span style={{ fontSize: "14px", color: "#fff" }}>
                              {Number(item.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "14px", color: "#fff" }}
                            />
                          </RatingBox>
                          <LikeBox
                            onClick={() => handleAddToWishList(item.product_id)}
                          >
                            <img src="/storage/general/Icon.svg" alt="wish" />
                          </LikeBox>
                          <CardImageContainer
                            className="top-selling"
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <img
                              src={producturl + item.thumbnail}
                              alt="Image not found"
                            />
                          </CardImageContainer>
                        </Top>
                        <Bottom className="withWhite">
                          <p
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {item.product_name}
                          </p>
                          <div className="flex items-baseline py-3">
                            <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                              ₹{item.sale_price}/-
                            </span>
                            {item.mrp && (
                              <span className="font-poppins font-light italic text-sm leading-none line-through text-[#db0f0f] ps-4">
                                {item.mrp}
                              </span>
                            )}
                          </div>
                          <button
                            onClick={() => handleAddCart(item.product_id)}
                            className={`
                            w-full h-[38px] flex items-center justify-center gap-[11px] rounded-[10px] 
                            font-poppins font-medium text-xs leading-none tracking-normal cursor-pointer opacity-100 
                            transition-all duration-300
                          ${item.sale_price > 3000
                                ? "bg-[#fa9801] !text-white hover:bg-white hover:!text-[#fa9801] hover:border hover:border-[#fa9801]"
                                : "border border-[#187837] text-[#187837] hover:bg-[#187837] hover:text-white"
                              }
  `}
                          >
                            Add to Cart
                          </button>
                        </Bottom>
                      </CardTopSelling>
                    );
                  })}
              </Slider>
            </div>
          </div>
          <div
            className="p-4 wrapper rounded-[27px] block md:hidden"
            style={{
              background:
                "linear-gradient(180deg, rgba(250, 152, 1, 0.64) 0%, rgba(255, 236, 208, 0.64) 100%)",
            }}
          >
            {" "}
            <h2>
              <ButtonContainer>
                <img
                  src="/storage/general/Top Selling Mobile.svg"
                  alt="top selling"
                />
                <div className="flex items-center gap-2">
                  <TopSellingButton onClick={handlePrev}>
                    <HiOutlineArrowLeft />
                  </TopSellingButton>
                  <TopSellingButton onClick={handleNext}>
                    <HiOutlineArrowRight />
                  </TopSellingButton>
                </div>
              </ButtonContainer>
            </h2>
            <div className="slider-container">
              <Slider ref={mobileSliderRef} {...Topsellingsettings}>
                {data &&
                  data.getTopSelling &&
                  data.getTopSelling.map((item, index) => {
                    return (
                      <CardMobile key={item.product_id}>
                        <Top>
                          <RatingBox>
                            <span style={{ fontSize: "12px", color: "#fff" }}>
                              {Number(item.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "12px", color: "#fff" }}
                            />
                          </RatingBox>
                          <LikeBox
                            onClick={() => handleAddToWishList(item.product_id)}
                          >
                            <img src="/storage/general/Icon.svg" alt="wish" />
                          </LikeBox>
                          <CardImageContainerMobile
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <img
                              src={producturl + item.thumbnail}
                              alt="Image not found"
                            />
                          </CardImageContainerMobile>
                        </Top>
                        <BottomMobile className="withWhite">
                          <p
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {trimText(item.product_name)}
                          </p>
                          <div className="flex items-baseline py-3">
                            <span className="text-[14px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                              ₹{item.sale_price}/-
                            </span>
                            {item.mrp && (
                              <span className="font-poppins font-light italic text-[9px] leading-none line-through text-[#db0f0f] ps-4">
                                {item.mrp}
                              </span>
                            )}
                          </div>
                          <button
                            onClick={() => handleAddCart(item.product_id)}
                            className={`
    w-[74px] h-[24px] flex items-center justify-center gap-[11px] rounded-[10px] 
    font-poppins font-medium text-[8px] leading-none tracking-normal cursor-pointer 
    opacity-100 transition-all duration-300
    ${item.sale_price > 3000
                                ? "bg-[#fa9801] !text-white hover:bg-white hover:!text-[#fa9801] hover:border hover:border-[#fa9801]"
                                : "border border-[#187837] text-[#187837] hover:bg-[#187837] hover:text-white"
                              }
  `}
                          >
                            Add to Cart
                          </button>

                        </BottomMobile>
                      </CardMobile>
                    );
                  })}
              </Slider>
            </div>
          </div>
        </TopSelling>
        {/* Top Selling section end */}
        {/* ----------------------------------------------------- */}

        {/* unveiling small screen */}

        <section className="wrapper block md:hidden">
          <Unveiling>
            <ImageContainer className="unveiling-banner ">
              <img src="/storage/general/banner1-2.png" alt="Image not found" />
            </ImageContainer>
            <div className="wrapper">
              <ContainerFull className="unveiling">
                <Left className="unveiling">
                  <span className="badge">Daily Ayurveda Spotlight</span>
                  <h3>Unveiling Ayurvedic Delights for the Day </h3>
                  <p className="subcopy">
                    Discover the essence of holistic wellness with our curated
                    selection of Ayurvedic treasures. From rejuvenating skin
                    care to nourishing herbal supplements, embark on a journey
                    of self-care and vitality.
                  </p>
                  <ul className="benefits">
                    <li>Curated rituals for balanced living</li>
                    <li>Authentic craftsmanship from Kerala</li>
                    <li>Freshly packed and delivered nationwide</li>
                  </ul>
                  <div className="cta-group">
                    <button onClick={handleAyurvedha}>
                      <span>Shop Now</span>
                      <span>
                        <HiOutlineArrowRight />
                      </span>
                    </button>
                    <button type="button" className="secondary" onClick={handleAyurvedha}>
                      Explore Ayurvedic Range
                    </button>
                  </div>
                </Left>
                <RightUnviel className="unveiling">
                  <div className="visual-card">
                    <div className="visual-glow" />
                    <ImageContainer className="unveiling">
                      <img
                        src="/storage/general/banner1-3.png"
                        alt="Image not found"
                      />
                    </ImageContainer>
                    <div className="visual-card__badge">Pure &amp; Potent</div>
                    <div className="visual-card__note">
                      <span>Hand-picked herbs, freshly crafted</span>
                      <span>Elevate your daily wellness ritual</span>
                    </div>
                  </div>
                </RightUnviel>
              </ContainerFull>
            </div>
          </Unveiling>
        </section>

        {/* Discover section start */}
        <section className="wrapper my-0 md:my-4">
          <Discover>
            <div className="wrapper">
              <ContainerFull className="discover">
                <Left className="discover">
                  <h3>Discover the Soul of Kerala.</h3>
                  <h5>
                    Experience Authentic Crafts, Handlooms & Ayurveda. Immerse
                    yourself in the rich heritage of Kerala.
                  </h5>
                  <p>Subscribe for our blogs...</p>
                  <form onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={subEmail}
                      onChange={(e) => setSubEmail(e.target.value)}
                      className="px-2"
                    />
                    <button type="submit">Subscribe</button>
                  </form>
                </Left>
                <RightDiscover className="discover">
                  <ImageContainer className="discover">
                    <img
                      src="/storage/general/banner1.png"
                      alt="Image not found"
                    />
                  </ImageContainer>
                </RightDiscover>
              </ContainerFull>
            </div>
          </Discover>
        </section>
        {/* Discover section end */}
        {/* ----------------------------------------------------- */}
      </main>
    </>
  );
}
export default HomepageNew;
const Section = styled.section`
  // experience
  &.experience {
    display: grid;

    place-items: center;
    border-right: 1px solid #000;
    margin: 20px 0;
    padding: 20px 0;
    &:last-child {
      border: none;
    }
    h5 {
      margin-top: 15px;
      margin-bottom: 15px;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      font-size: 20px;
      font-family: "Poppins", sans-serif;
      @media screen and (max-width: 640px) {
        font-size: 16px;
      }
    }
    @media screen and (max-width: 768px) {
      margin: 0;
      padding: 0;
      border-right: none;
      padding-bottom: 10px;
      border-bottom: 1px solid #000;
      margin: 0 20px;
      &:first-child {
        margin-top: 40px;
        @media screen and (max-width: 640px) {
          margin-top: 25px;
        }
      }
      &:last-child {
        margin-bottom: 40px;
        @media screen and (max-width: 640px) {
          margin-bottom: 20px;
        }
      }
    }
  }
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const Container = styled.div`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 239, 217, 1);
  // experience
  &.experience {
    background-color: #fff;
    border: 1px solid rgba(255, 239, 217, 1);
    border-radius: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    color: rgba(0, 0, 0, 1);
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  &.deals {
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: start;
  }
  // popular
  // unveiling
  &.unveiling {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    align-items: start;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  &.discover {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media screen and (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  // topselling
  // discover
`;
const Hero = styled.div`
  @media screen and (max-width: 540px) {
    display: none;
  }
  .slider-container {
    max-height: 630px;

    @media screen and (max-width: 1024px) {
      max-height: 450px;
    }
    @media screen and (max-width: 768px) {
      max-height: 305px;
    }
  }
`;
const Experience = styled.div`
  position: relative;
  bottom: -20px;

  @media screen and (min-width: 1441px) {
    bottom: -30px;
  }

  @media screen and (max-width: 1280px) {
    bottom: -10px;
  }
  
  @media screen and (max-width: 1024px) {
    bottom: 0px;
  }

  &.top {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  &.bottom {
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
    }
  }
`;
const Deals = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 15px;
  padding: 40px;
  border-radius: 40px;
  background: linear-gradient(180deg, #ffefd9 0%, #f4f4f4 100%);
  justfy-content: center;
  @media screen and (max-width: 1400px) {
    grid-template-columns: 2fr 0.7fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 15px;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;
const MobileDeals = styled.div`
  display: none;
  @media screen and (max-width: 640px) {
    display: block;
    // padding-top: 40px;
    .slick-slide {
      max-width: 240px;
      padding-right: 5px;
    }
  }
`;
const Popular = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 10px;
  padding-top: 40px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;
const ItalicText = styled.b`
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  display: block;
  color: rgba(0, 0, 0, 1);
`;
const View = styled.button`
  display: grid;
  justify-items: end;
  width: 100%;
  background: none;
  border: none;
  padding-bottom: 30px;
  button {
    background-color: #fc9800;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-weight: 500;
  }
`;
const PopularInner = styled.div`
  padding: 30px 0;
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  gap: 10px;
  padding-top: 40px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;
const Unveiling = styled.div`
  background-color: #084c27;
  padding: 40px 0;
  position: relative;
  border-radius: 36px;
`;
const TopSelling = styled.div`
  padding: 60px 0;
  padding-bottom: 0;
  h2 {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .slick-slide {
    padding-right: 5px;
    max-height: 420px;
  }
  .slick-slider {
    max-height: 420px;
  }
  .slider-container {
    max-height: 420px;
  }
`;
const Discover = styled.div`
  background-color: #ffedd4;
  padding: 60px 0;
  border-radius: 36px;
`;
const Left = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 15px;
  align-items: flex-start;
  @media screen and (max-width: 1600px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  &.deals-left {
    // border: 1px solid #ececec;
    // padding: 10px;
    border-radius: 10px;
    height: fit-content;
  }
  &.unveiling {
    gap: 24px;
    grid-template-columns: 1fr;
    align-items: start;
    justify-items: start;
    .badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px 14px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.12);
      color: #ffdda4;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.08em;
    }
    h3 {
      font-size: 40px;
      text-transform: uppercase;
      font-weight: 600;
      color: #fff;
      @media screen and (max-width: 540px) {
        ffont-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 27px;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 0%;
        ont-size: 27px;
      }
    }
    .subcopy {
      color: rgba(255, 255, 255, 0.86);
      font-size: 18px;
      line-height: 1.6;
      max-width: 520px;
      @media screen and (max-width: 540px) {
        font-family: Poppins;
        font-weight: 500;
        font-size: 17px;
        text-align: justify;
      }
    }
    .benefits {
      display: grid;
      gap: 12px;
      padding: 0;
      margin: 0;
      list-style: none;
      li {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.92);
        font-weight: 500;
        &::before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #fc9800;
          flex-shrink: 0;
        }
      }
    }
    .cta-group {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      align-items: center;
      button {
        background-color: #fc9800;
        color: #fff;
        border: none;
        border-radius: 14px;
        padding: 12px 26px;
        display: inline-flex;
        align-items: center;
        gap: 16px;
        font-size: 16px;
        font-weight: 600;
        box-shadow: 0 12px 24px rgba(252, 152, 0, 0.28);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        svg {
          font-size: 20px;
          color: #fff;
        }
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(252, 152, 0, 0.36);
        }
      }
      .secondary {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.6);
        color: #fff;
        padding: 12px 22px;
        box-shadow: none;
        gap: 10px;
        svg {
          font-size: 18px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.12);
        }
      }
      @media screen and (max-width: 540px) {
        flex-direction: column;
        align-items: stretch;
        button,
        .secondary {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }
  &.discover {
    grid-template-columns: 1fr;

    h5 {
      font-weight: 500;
      margin-bottom: 20px;
    }
    h3 {
      font-weight: 600;
      margin-bottom: 20px;
      text-transform: uppercase;
      font-size: 42px;
      @media screen and (max-width: 640px) {
        font-size: 30px;
      }
    }
    form {
      display: flex;
      width: 70%;
      margin: 20px 0;
      input {
        border-radius: 10px 0 0 10px;
      }
      button {
        border-radius: 0 10px 10px 0;
        height: 100%;
        padding: 10px;
      }
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
`;

const Card = styled.div`
  border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 255px;
  cursor: pointer;
  background-color: #fff;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.32);
    transform: translateY(-2px);
  }
`;

const CardMobile = styled.div`
  border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 267px;
  max-height: 290px;
  min-width: 167px;
  p {
    min-height: 28px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 10px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.32);
  }
`;

const CardTopSelling = styled.div`
  // border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 290px;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
`;
const CardRight = styled.div`
  border: 1px solid rgba(250, 152, 1, 1);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 255px;
  background-color: #fff;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 12px rgba(250, 152, 1, 1);
    transform: translateY(-2px);
  }

  @media (min-width: 800px) {
    min-width: 250px;
  }
`;
const Top = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 150px;
`;
const Bottom = styled.div`
  padding: 10px 20px;
  border-radius: 0 0 10px 8px;

  &.withWhite {
    background-color: #fff;
  }
  &.withbg {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 22px;
      padding: 10px 0;
      font-weight: 600;
    }
  }
  &.withbg-right {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 15px;
      padding: 10px 0;
      font-weight: 400;
    }
  }
`;
const BottomMobile = styled.div`
  padding: 10px 10px;
  border-radius: 0 0 10px 8px;

  &.withWhite {
    background-color: #fff;
  }
  &.withbg {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 10px;
      padding: 10px 0;
      font-weight: 500;
    }
  }
  &.withbg-right {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 15px;
      padding: 10px 0;
      font-weight: 400;
    }
  }
`;
const CartBtn = styled.div`
  button {
    border: none;
    padding: 10px;
    border-radius: 10px;
    &.green {
      background-color: #389763;
      svg {
        color: #fff;
      }
    }
    background-color: #fff;

    svg {
      color: #ad4b0e;
      font-size: 20px;
    }
  }
`;
const DescriptionButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
    min-height: 35px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;
const Like = styled.div`
  background-color: transparent;
  padding: 10px;
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 10px;
  color: #000;
  svg {
    font-size: 22px;
    fill: rgba(217, 217, 217, 1);
    &:hover {
      color: red;
    }
  }
`;
const CardImageContainer = styled.div`
  // margin-top: 10px;
  height: 200px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;

    display: block;
  }
  @media screen and (max-width: 420px) {
    height: 150px;
    width: unset;
    img {
      object-fit: contain;
    }
  }
  &.top-selling {
    img {
      object-fit: cover;
    }
    @media screen and (max-width: 420px) {
      height: 210px;
      width: unset;
    }
  }
  &.fullHeight {
    /* height: calc(100% - 170px); */
  }
`;
const CardImageContainerMobile = styled.div`
  // margin-top: 10px;
  height: 120px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;

    display: block;
  }
  @media screen and (max-width: 420px) {
    height: 150px;
    width: unset;
    img {
      object-fit: contain;
    }
  }
  &.top-selling {
    img {
      object-fit: cover;
    }
    @media screen and (max-width: 420px) {
      height: 120px;
      width: unset;
    }
  }
  &.fullHeight {
    /* height: calc(100% - 170px); */
  }
`;
const Right = styled.div`
  display: grid;
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  @media screen and (max-width: 1400px) {
    grid-template-columns: 1fr;
    // max-width: 255px;
  }
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    // width: 100%;
    // display: -webkit-inline-box;
  }
`;

const RightDiscover = styled.div`
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  @media screen and (max-width: 1500px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

const MobileHero = styled.div`
  display: none;
  @media screen and (max-width: 540px) {
    display: block;
  }
  .slider-container {
    @media screen and (max-width: 540px) {
      max-height: 540px;
    }
    @media screen and (max-width: 430px) {
      max-height: 200px;
    }
    @media screen and (max-width: 340px) {
      height: 200px;
    }
  }
`;
const Slide = styled.div`
  // hero
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 30%;
      left: 125px;
      @media screen and (max-width: 1024px) {
        left: 88px;
      }
      @media screen and (max-width: 768px) {
        left: 95px;
        bottom: 25%;
      }
      border: none;
      padding: 10px 20px;
      min-width: max-content;
      border-radius: 10px;
      display: flex;
      gap: 20px;
      align-items: center;
      justify-content: center;
      a,
      svg {
        font-size: 18px;
        color: white;
      }
    }
  }
  // experience
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const MobileSlide = styled.div`
  // hero
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 20%;
      left: 50%;
      transform: translate(-50%, 50%);
      border: none;
      padding: 5px 10px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      a,
      svg {
        font-size: 18px;
        color: white;
      }
    }
  }
  // experience
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const ImageContainer = styled.div`
  // hero
  &.hero {
    height: 630px;
    width: 100%;
    @media screen and (max-width: 1024px) {
      height: 450px;
    }
    @media screen and (max-width: 768px) {
      width: 90%;
      margin: auto;
      height: 305px;
    }
    @media screen and (max-width: 540px) {
      height: 540px;
    }
    @media screen and (max-width: 430px) {
      height: 200px;
    }
    @media screen and (max-width: 340px) {
      height: 200px;
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    @media screen and (max-width: 768px) {
      border-radius: 10px;
    }
  }
  // experience
  &.experience {
    background: #ad4b0e;
    height: 40px;
    width: 40px;
    padding: 7px;
    border-radius: 8px;
  }
  // deals
  // popular
  // unveiling
  &.unveiling-banner {
    position: absolute;
    left: 24px;
    bottom: 24px;
    img {
      height: 180px;
      width: 180px;
      object-fit: cover;
    }
  }
  &.unveiling {
    height: 340px;
    display: grid;
    place-items: center;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    @media screen and (max-width: 540px) {
      height: 250px;
    }
  }
  // deals
  // topselling
  // discover
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  padding-bottom: 40px;
  @media screen and (max-width: 540px) {
    padding-bottom: 0px;
  }
`;
const TopSellingButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid rgba(250, 152, 1, 1);
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    color: rgba(250, 152, 1, 1);
    transition: color 0.3s ease;
    font-size: 20px;
  }

  &:hover {
    background-color: rgba(250, 152, 1, 1);

    svg {
      color: #fff;
    }
  }
`;

const RatingBox = styled.div`
  position: absolute;
  top: 7px;
  left: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  border-radius: 4px;
  gap: 2px;
  padding: 0 8px;
  background-color: rgba(24, 120, 55, 1); /* Or any background */
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;
const LikeBox = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 24px;

  z-index: 2;
`;
const OutlinedGreenButton = styled.button`
  width: 100%;
  height: 38px;
  background-color: #ffffff;
  border: 1px solid rgba(24, 120, 55, 1);
  color: rgba(24, 120, 55, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  cursor: pointer;
  opacity: 1;

  &:hover {
    background-color: rgba(24, 120, 55, 1);
    color: #ffffff;
  }
`;
const OutlinedOrangeButton = styled.button`
  width: 100%;
  height: 38px;
  background-color: rgba(250, 152, 1, 1);
  border: 1px solid rgba(250, 152, 1, 1);
  color: fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  cursor: pointer;
  opacity: 1;

  &:hover {
    background-color: #ffffff;
    color: rgba(250, 152, 1, 1);
  }
`;

export const PromoCard = styled.div`
  width: 255px;
  height: 255px;
  background-color: #005c2e;
  border-radius: 8px;
  padding: 20px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    font-weight: 500;
    font-size: 18px;
    span {
      color: #f7b500;
    }
  }

  h5 {
    font-size: 14px;
    font-weight: 400;
  }

  button {
    background: white;
    border: none;
    border-radius: 6px;
    color: #005c2e;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 10px;
  }
`;

const ContainerFull = styled.div`
  // experience
  &.experience {
    background-color: #fff;
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  &.deals {
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: start;
  }
  // popular
  // unveiling
  &.unveiling {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    align-items: start;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  &.discover {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media screen and (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  // topselling
  // discover
`;

const RightUnviel = styled.div`
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1500px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
  &.unveiling {
    width: 100%;
    .visual-card {
      position: relative;
      width: min(360px, 100%);
      padding: 30px 28px 36px;
      border-radius: 28px;
      background: linear-gradient(162deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
      border: 1px solid rgba(255, 255, 255, 0.18);
      backdrop-filter: blur(12px);
      display: grid;
      gap: 18px;
      justify-items: center;
      overflow: hidden;
    }
    .visual-glow {
      position: absolute;
      inset: -40% -20%;
      background: radial-gradient(circle at center, rgba(252, 152, 0, 0.35) 0%, rgba(8, 76, 39, 0.05) 70%);
      filter: blur(40px);
      z-index: 0;
    }
    .visual-card > * {
      position: relative;
      z-index: 1;
    }
    .visual-card__badge {
      padding: 6px 18px;
      border-radius: 999px;
      background: rgba(8, 76, 39, 0.85);
      color: #ffdda4;
      font-weight: 600;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      font-size: 12px;
    }
    .visual-card__note {
      display: grid;
      gap: 6px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.84);
      text-align: center;
      span:first-child {
        font-weight: 600;
      }
    }
    @media screen and (max-width: 540px) {
      .visual-card {
        width: 100%;
        padding: 26px 22px 32px;
      }
      .visual-card__note {
        font-size: 13px;
      }
    }
  }
`;

const PopularMain = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1.5fr;
  gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
